import { Button, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

const { media, mediaQueries } = theme;

const BUTTON_GAP = '1rem';
export const FilterWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${BUTTON_GAP};
  margin-bottom: 2rem;
`;

export const StyledButton = styled(Button)`
  border-radius: 0.25rem;
  padding: 0.5rem 2rem;
  width: calc(50% - calc(${BUTTON_GAP} / 2));

  ${mediaQueries.above(media.md)} {
    width: auto;
  }
`;

export const Wrapper = styled.div`
  padding-bottom: 3rem;
`;
